import React from 'react';
import { Button } from './button';
import { createStyles } from '@/contexts/theme-context';
import { useLayoutContext } from '@/contexts/layout-context';
import { WelcomePageButtonConfig } from './welcome-page-types';

interface Props {
  appBackgroundImageUrl?: string;
  appBackgroundVideoUrl?: string;
  buttonConfig: WelcomePageButtonConfig;
  welcomeScreenActive: boolean;
}

export const WelcomePageButton: React.FC<Props> = ({
  buttonConfig,
  welcomeScreenActive,
  appBackgroundVideoUrl,
  appBackgroundImageUrl,
}) => {
  const [styles] = useStyles();
  const { isLargeLayout } = useLayoutContext();

  return (
    <Button
      containerStyle={[
        styles.buttonContainer,
        isLargeLayout ? styles.buttonContainerLarge : null,
        !welcomeScreenActive && !isLargeLayout ? styles.noWidthLimit : null,
      ]}
      onPress={buttonConfig.onPress}
      style={[
        styles.button,
        buttonConfig.isPrimary
          ? styles.signInButton
          : [
              styles.exploreCatalogButton,
              !welcomeScreenActive ||
              !(appBackgroundVideoUrl || appBackgroundImageUrl)
                ? styles.exploreCatalogButtonBorder
                : null,
            ],
      ]}
      textStyle={
        buttonConfig.isPrimary
          ? styles.signInButtonText
          : styles.exploreCatalogButtonText
      }
      trackingData={{ name: buttonConfig.trackingName }}
    >
      {buttonConfig.text}
    </Button>
  );
};

const useStyles = createStyles((theme) => ({
  button: {
    borderWidth: 0,
    marginHorizontal: 'auto',
    marginVertical: 10,
    width: '100%',
  },
  buttonContainer: {
    flexShrink: 1,
    maxWidth: 500,
    width: '100%',
  },
  buttonContainerLarge: {
    maxWidth: 300,
  },
  exploreCatalogButton: {
    backgroundColor: theme.colors.authBackground,
  },
  exploreCatalogButtonBorder: {
    borderColor: theme.colors.primaryOverlay,
    borderWidth: 1,
  },
  exploreCatalogButtonText: {
    color: theme.colors.primary,
    textAlign: 'center',
  },
  noWidthLimit: {
    maxWidth: '100%',
  },
  signInButton: {
    backgroundColor: theme.colors.accent,
  },
  signInButtonText: {
    color: theme.colors.accentText,
    textAlign: 'center',
  },
}));
